import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_MBIZUSER, IS_MOBILE_OR_TABLET_BROWSER, IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';

const condition = !IS_ONPREMISE && !IS_BIZ_USER && !IS_MBIZUSER && !IS_MOBILE_OR_TABLET_BROWSER;

export const publicInfoFolderContextMenuEnabled = condition && isFeature('public-info-folder-ctx-menu');
export const publicInfoFileContextMenuEnabled = condition && isFeature('public-info-file-ctx-menu');
export const publicInfoAlbumContextMenuEnabled = condition && isFeature('public-info-album-ctx-menu');
export const publicInfoFolderToobarEnabled = condition && isFeature('public-info-folder-toolbar');
export const publicInfoFileToobarEnabled = condition && isFeature('public-info-file-toolbar');
export const publicInfoAlbumToolbarEnabled = condition && isFeature('public-info-album-toolbar');
export const publicInfoFileViewerToolbarEnabled = condition && isFeature('public-info-file-viewer-toolbar');
